import React from 'react'
import styled from 'styled-components'


const Columns = ({ width = "100%", cols = "2 100px", gap = "20px", children }) => {


    return (
        <Wrap $width={width} $cols={cols} $gap={gap}>{children}</Wrap>
    )
}

export default Columns


const Wrap = styled.div`
width: ${(props) => (props.$width)};
display: block;
columns: ${(props) => (props.$cols)};
column-gap: ${(props) => (props.$gap)};

& > div {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
}

`